import { useMutation, useQueryClient } from 'react-query';

import { deleteAiThread } from '@utils/backend-api/aiThread';

import { AI_ALERT_SUBSCRIPTIONS_KEY } from './useAiAlertSubscriptions';
import { AI_THREADS_KEY } from './useAiThreads';

export default function useAiThreadDelete() {
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, data, isLoading, isError, error } = useMutation(
    (threadId: string) => deleteAiThread(threadId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([AI_THREADS_KEY]);
        queryClient.invalidateQueries([AI_ALERT_SUBSCRIPTIONS_KEY]);
      },
    }
  );

  return {
    mutate,
    mutateAsync,
    data,
    isLoading,
    isError,
    error,
  };
}
